import React, { useState } from 'react';
import { bindActionCreators, compose } from 'redux';
import { connect } from 'react-redux';
import { downloadInvoice, fetchInvoices } from '../../../actions/report-actions';
import { FormattedMessage } from 'react-intl';
import CommonTable from '../../common/table/CommonTable';
import { formatTimestampAsDate } from '../../../utils/dates-utils';
import { VerticalAlignBottomOutlined } from '@material-ui/icons';
import IconButton from '@material-ui/core/IconButton';
import MoneyFormat, { VAT_RATE } from '../../common/MoneyFormat';
import Tooltip from '@material-ui/core/Tooltip';
import LoadingSnackbar from '../../common/LoadingSnackbar';
import PropTypes from 'prop-types';

const INVOICE_TABLE_CONFIG = (downloadInvoice, setDownloadProgress) => [
  {
    header: <FormattedMessage id="page.invoices.table.header.invoice.number" defaultMessage="Invoice number" />,
    value: data => <>{data.Id}
      <Tooltip
        placement="right"
        title={<FormattedMessage id="page.invoices.table.tooltip.download.invoice"
                                 defaultMessage="Download invoice" />}
      >
        <IconButton
          onClick={downloadInvoice.bind(this, setDownloadProgress, data.Id)}>
          <VerticalAlignBottomOutlined />
        </IconButton>
      </Tooltip>
    </>,
  },
  {
    header: <FormattedMessage id="page.invoices.table.header.invoice.date" defaultMessage="Invoice date" />,
    value: data => formatTimestampAsDate(data.InvoiceDate),
  },
  {
    header: <FormattedMessage id="page.invoices.table.header.total.amount.excluding.vat"
                              defaultMessage="Total Amount excluding vat" />,
    value: data => <MoneyFormat value={data.TotalAmountExcludingVat} />,
    align: 'right',
  },
  {
    header: <FormattedMessage id="page.invoices.table.header.total.amount.including.vat"
                              defaultMessage="Total Amount" />,
    value: data => <MoneyFormat value={data.TotalAmountExcludingVat * VAT_RATE} />,
    align: 'right',
  },
];

const Invoices = ({ invoices, fetchInvoices, downloadInvoice }) => {
  const [downloadProgress, setDownloadProgress] = useState(null);
  
  React.useEffect(() => {
    fetchInvoices();
  }, [fetchInvoices]);
  
  return (
    <>
      <LoadingSnackbar
        downloadFile={true}
        progress={downloadProgress}
        label={<FormattedMessage id="loading" defaultMessage="Loading" />}
      />
  
      {invoices && <CommonTable
        data={invoices.sort((a, b) => b.Id - a.Id)}
        title={<FormattedMessage
          id="page.invoices.table.title"
          defaultMessage="Invoices"
        />}
        tableConfig={INVOICE_TABLE_CONFIG(downloadInvoice, setDownloadProgress)}
      />}

    </>
  );
};

Invoices.propTypes = {
  invoices: PropTypes.array,
  fetchInvoices: PropTypes.func,
  downloadInvoice: PropTypes.func,
};

const decorate = compose(
  connect(
    store => ({ invoices: store.user.invoices }),
    dispatch => bindActionCreators({ fetchInvoices, downloadInvoice }, dispatch)),
);

export default decorate(Invoices);